import { FC, useMemo } from 'react';
import { ToolbarButton, ToolbarButtonProps } from './ToolbarButton';
import {
  Divider,
  Heading,
  Kbd,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { Trans, useTranslation } from 'react-i18next';

export type InfoButtonProps = ToolbarButtonProps & {
  allowLists: boolean;
  allowLinks: boolean;
};

export const InfoButton: FC<InfoButtonProps> = ({ allowLinks, allowLists, ...rest }) => {
  const { t } = useTranslation('html-editor');
  const transComponents = useMemo(
    () => ({
      Heading: <Heading size="sm" my={1} />,
      Text: <Text my={1} />,
      Kbd: <Kbd color="inherit" />,
    }),
    []
  );

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <ToolbarButton {...rest}>
          <InfoIcon />
        </ToolbarButton>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>{t('htmlEditor.infoPopup.title')}</PopoverHeader>
        <PopoverBody>
          <Trans t={t} i18nKey="htmlEditor.infoPopup.content.shortcuts" components={transComponents} />
          <Divider my={4} />
          {allowLists && (
            <>
              <Trans t={t} i18nKey="htmlEditor.infoPopup.content.lists" components={transComponents} />
              <Divider my={4} />
            </>
          )}
          <Trans t={t} i18nKey="htmlEditor.infoPopup.content.newLines" components={transComponents} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
